import { render } from "./TeacherPass.vue?vue&type=template&id=483550f0"
import script from "./TeacherPass.vue?vue&type=script&lang=js"
export * from "./TeacherPass.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__